<mat-expansion-panel
  class="mc-expansion-panel"
  (opened)="opened.emit()"
  [expanded]="isExpanded"
  #expansionPanel
  hideToggle
>
  <mat-expansion-panel-header #panelHeader class="mc-expansion-panel__header">
    <div class="mc-expansion-panel__title">
      <mat-panel-title class="mc-expansion-panel__header-title">
        <ng-content select="[title-elem]"></ng-content>
        <span class="mc-expansion-panel__header-title-btn__arrow" [ngClass]="{'is-opened': expansionPanel.expanded}">
          <mat-icon svgIcon="triangle_right" aria-hidden="true"></mat-icon>
        </span>
      </mat-panel-title>
      <ng-content select="[sub-title]"></ng-content>
    </div>
    <mat-panel-description><ng-content select="[description]"></ng-content></mat-panel-description>
  </mat-expansion-panel-header>
  <div class="mc-expansion-panel__body">
    <ng-content select="[body]"></ng-content>
  </div>
</mat-expansion-panel>
